<template>
  <v-card class="text-center pa-6">
    <v-icon size="64" color="primary" class="mb-4">mdi-clock-outline</v-icon>
    <h2 class="mb-4">Видео будет доступно</h2>
    <p class="text-h6 mb-2">{{ formattedDate }}</p>
    <p class="text-body-2 text--secondary">
      Следующее видео станет доступно для просмотра в указанное время
    </p>
    <v-progress-circular
      v-if="timeRemaining > 0"
      :value="progressValue"
      size="80"
      width="8"
      color="primary"
      class="mt-4"
    >
      <span class="text-caption">{{ timeRemainingText }}</span>
    </v-progress-circular>
  </v-card>
</template>

<script>
export default {
  name: "VideoAvailabilityMessage",
  props: {
    playbackAvailabilityTime: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timeRemaining: 0,
      interval: null,
    };
  },
  computed: {
    formattedDate() {
      const date = new Date(this.playbackAvailabilityTime);
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return date.toLocaleString("ru-RU", options);
    },
    progressValue() {
      const totalTime = 24 * 60 * 60; // 24 часа в секундах
      return Math.max(
        0,
        Math.min(100, ((totalTime - this.timeRemaining) / totalTime) * 100)
      );
    },
    timeRemainingText() {
      if (this.timeRemaining <= 0) return "Доступно!";

      const hours = Math.floor(this.timeRemaining / 3600);
      const minutes = Math.floor((this.timeRemaining % 3600) / 60);
      const seconds = this.timeRemaining % 60;

      if (hours > 0) {
        return `${hours}ч ${minutes}м`;
      } else if (minutes > 0) {
        return `${minutes}м ${seconds}с`;
      } else {
        return `${seconds}с`;
      }
    },
  },
  mounted() {
    this.updateTimeRemaining();
    this.interval = setInterval(this.updateTimeRemaining, 1000);
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    updateTimeRemaining() {
      const now = new Date();
      const targetTime = new Date(this.playbackAvailabilityTime);
      const diff = Math.floor((targetTime - now) / 1000);

      this.timeRemaining = Math.max(0, diff);

      if (this.timeRemaining <= 0 && this.interval) {
        clearInterval(this.interval);
        this.$emit("video-available");
      }
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 16px auto;
}
</style>
